// extracted by mini-css-extract-plugin
export var modalFooter = "_pq-0";